<template>
    <div class="poster">
        <div class="title">
            <p>福利卡</p>
        </div>
        <div class="main">
            <div class="price">
                <p>当前可使用金额：{{ balance }}元</p>
                <el-button type="primary" @click="showPay">充 值</el-button>
            </div>
            <div class="form">
                <el-form :inline="true" :model="formInline" class="demo-form-inline">
                    <el-form-item v-show="activeName == 2">
                        <el-input v-model="formInline.order_sn" placeholder="请输入订单号" clearable></el-input>
                    </el-form-item>
                    <el-form-item v-show="activeName == 1">
                        <el-input v-model="formInline.name" placeholder="请输入卡券名称" clearable></el-input>
                    </el-form-item>
                    <el-form-item v-show="activeName == 1">
                        <el-select v-model="formInline.type">
                            <el-option label="正常" value="1"></el-option>
                            <el-option label="已过期" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">查 询</el-button>
                        <!-- <el-button type="primary" @click="reset">重 置</el-button> -->
                    </el-form-item>
                    <el-form-item style="float: right">
                        <el-button @click="createCard" type="primary">创建福利卡</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="main table">
            <div class="tabs">
                <el-tabs v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane label="福利卡" name="1"> </el-tab-pane>
                    <el-tab-pane label="充值记录" name="2"> </el-tab-pane>
                </el-tabs>
            </div>
            <div class="table">
                <el-table :data="tableData" style="width: 100%" v-loading="tabload" v-if="activeName == 1">
                    <el-table-column prop="id" label="ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="title" width="160px" show-overflow-tooltip="" label="福利卡名称" align="center"> </el-table-column>
                    <el-table-column prop="amount" label="面额" align="center">
                        <template slot-scope="{ row }">{{ row.amount | numFmt }}</template>
                    </el-table-column>
                    <el-table-column prop="number" width="160px" label="发行总数" align="center"> </el-table-column>
                    <el-table-column prop="give_number" width="160px" label="已发卡数" align="center"> </el-table-column>
                    <el-table-column prop="use_number" width="160px" label="已使用数" align="center"> </el-table-column>
                    <el-table-column prop="able_start_time" width="160px" label="开始时间" align="center"> </el-table-column>
                    <el-table-column prop="able_end_time" width="160px" label="结束时间" align="center"> </el-table-column>
                    <el-table-column prop="status" width="160px" label="状态" align="center">
                        <template slot-scope="{ row }">
                            {{ row.is_normal == 1 ? "正常" : "已过期" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="opt" label="操作" align="center" fixed="right" width="180px">
                        <template slot-scope="scope">
                            <div class="link">
                                <el-link type="primary" @click="detail(scope.row.id)">查看</el-link>
                                <el-link type="primary" @click="importCard(scope.row.id)">导入发卡</el-link>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
                <el-table :data="tableData" style="width: 100%" v-loading="tabload" v-if="activeName == 2">
                    <el-table-column prop="id" label="ID" align="center" width="80px"> </el-table-column>
                    <el-table-column prop="orders_sn" show-overflow-tooltip="" width="200px" label="订单编号" align="center"> </el-table-column>
                    <el-table-column prop="id" label="业务" align="center">
                        <template> 卡券充值 </template>
                    </el-table-column>
                    <el-table-column prop="totals_amounts" label="充值金额 (元)" align="center"> </el-table-column>
                    <el-table-column prop="create_times" width="160px" label="创建时间" align="center"> </el-table-column>
                    <el-table-column prop="trades_status " width="160px" label="订单状态" align="center">
                        <template slot-scope="{ row }">{{ row.trades_status == 0 ? "支付中" : row.trades_status == 1 ? "支付成功" : "支付失败" }}</template>
                    </el-table-column>
                    <el-table-column prop="online_type" width="160px" label="支付渠道" align="center">
                        <template slot-scope="{ row }">
                            {{ row.online_type == 1 ? "支付宝" : row.online_type == 2 ? "微信" : "通联" }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="payments_codes" width="160px" label="支付方式" align="center">
                        <template slot-scope="{ row }">
                            {{ row.payments_codes.trim() == "WeChatPay" ? "微信" : "支付宝" }}
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div class="pageList">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="page"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="size"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total"
                    background
                >
                </el-pagination>
            </div>
        </div>
        <CreateCard ref="refCreateCard" @init="init"></CreateCard>
        <Pay ref="refPay"></Pay>
        <HistoryList ref="refHistoryList"></HistoryList>
        <Import ref="refImport" @init="init"></Import>
    </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import CreateCard from "@/components/Modules/CardManage/CreateCard.vue";
import Pay from "@/components/Modules/CardManage/Pay.vue";
import HistoryList from "@/components/Modules/CardManage/HistoryList.vue";
import Import from "@/components/Modules/CardManage/Import.vue";
export default {
    components: {
        CreateCard,
        Pay,
        HistoryList,
        Import,
    },
    data() {
        return {
            tabload: false,
            page: 1,
            size: 10,
            total: 0,
            tableData: [],
            formInline: {
                order_sn: "",
                name: "",
                type: "",
            },
            activeName: "1",
            type: "",
            balance: "",
        };
    },
    filters: {
        numFmt(val) {
            return Number(val).toFixed(2);
        },
    },
    computed: {
        ...mapGetters(["getToken", "getAppVerify"]),
    },
    created() {
        this.getList(1);
        this.getBalance();
    },
    methods: {
        ...mapActions({
            couponsList: "detect/couponsList",
            paymentList: "detect/paymentList",
            couponsCardBalance: "detect/couponsCardBalance",
        }),
        init() {
            this.getList(1);
            this.getBalance();
        },
        getBalance() {
            this.couponsCardBalance({ token: this.getToken }).then(({ data }) => {
                if (data.code == 1) {
                    this.balance = data.data.card_balance || 0;
                }
            });
        },
        importCard(id) {
            this.$refs.refImport.id = id;
            this.$refs.refImport.dialogVisible = true;
        },
        detail(id) {
            this.$refs.refHistoryList.dialogVisible = true;
            this.$refs.refHistoryList.id = id;
            this.$refs.refHistoryList.getCategoryList();
        },
        createCard() {
            if (this.getAppVerify.length > 0) {
                let f = false;
                if (this.getAppVerify.some((item) => item.code == "WEAL_PRESENT_CARD")) {
                    this.getAppVerify.forEach((item) => {
                        if (item.code == "WEAL_PRESENT_CARD") {
                            if (item.is_free != 1 && item.merchant_status != 1) {
                                f = true;
                                this.$message.warning("请先前往 商品管理->营销玩法 购买此应用！");
                            }
                        }
                    });
                } else {
                    this.$message.warning("请先前往 商品管理->营销玩法 购买此应用！");
                    return
                }
                if (f) {
                    return;
                }
            }
            this.$refs.refCreateCard.dialogVisible = true;
        },
        showPay() {
            this.$refs.refPay.dialogVisible = true;
        },
        getList(tag) {
            this.tabload = true;
            let opt = {
                token: this.getToken,
                page: tag == 1 ? 1 : this.page, //页数
            };
            let url;
            if (this.activeName == 1) {
                url = this.couponsList;
                opt.title = this.formInline.name;
                opt.status = this.formInline.type;
                opt.page_size = this.size; //页大小
            } else {
                url = this.paymentList;
                opt.order_sn = this.formInline.order_sn;
                opt.size = this.size; //页大小
            }
            url(opt).then(({ data }) => {
                this.tabload = false;
                if (data.code == 1) {
                    if (this.activeName == 1) {
                        this.tableData = data.data.data;
                        this.total = data.data.count ? Number(data.data.count) : 0;
                    } else {
                        this.tableData = data.data.list;
                        this.total = data.data.count ? Number(data.data.count) : 0;
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        handleSizeChange(val) {
            this.size = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.page = val;
            this.getList();
        },
        onSubmit() {
            this.getList(1);
        },
        reset() {
            this.formInline = {
                type: "",
                order_sn: "",
                name: "",
            };
            this.getList(1);
        },
        handleClick() {
            this.tableData = [];
            this.getList(1);
        },
    },
};
</script>
<style lang="scss" scoped>
.poster {
    position: relative;
    height: 100%;
    .table {
        padding: 20px;
    }
    ::v-deep .el-tabs__item {
        text-align: center;
    }

    .title {
        width: 100%;
        background: #fff;
        padding: 15px 32px;
        display: flex;
        align-items: center;
        box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
        p {
            font-size: 16px;
            color: #333;
            margin-left: 32px;

            span {
                color: #e72f0d;
                padding: 0 5px;
            }

            &:first-child {
                font-size: 18px;
                color: #333;
                margin-left: 0;
            }

            &:nth-child(2) {
                span {
                    color: #2448ff;
                }
            }
        }
    }
    .main.table {
        min-width: 1200px;
        min-height: 500px;
        .table {
            min-height: 450px;
        }
    }
    .main {
        min-width: 1200px;
        box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
        background: #fff;
        margin: 24px;
        padding: 24px;
        ::v-deep .el-form-item {
            margin-bottom: 0;
        }
        .tabs {
            position: relative;
        }
        .btnlist {
            position: absolute;
            right: 0;
            bottom: 28px;
        }
        span {
            margin-right: 10px;

            ::v-deep .el-input {
                width: 150px;
                display: inline-block;
            }
        }

        ::v-deep .el-table th {
            background: #fafafa;
            padding: 10px 0;
        }
        .price {
            margin-bottom: 22px;
            display: flex;
            p {
                margin-right: 22px;
                font-size: 18px;
                color: #333;
                font-weight: 600;
                line-height: 36px;
            }
        }
    }
}
.pageList {
    text-align: right;
    margin-top: 20px;
}
.link {
    a {
        margin: 0 12px;
    }
}
.dot {
    ::v-deep .el-badge__content.is-dot {
        left: -24px;
        top: 10px;
    }
}

.tabs {
    ::v-deep .el-badge__content.is-fixed {
        top: 20px;
        right: -10px;
    }
}
</style>